<div class="grid gap-4 md:grid-cols-2">
  <!-- Group Card -->
  <div class="card">
    <div>
      <h1 class="text-lg font-semibold text-dc-navy">
        {{ groupName }}
      </h1>
      <span class="dc-status-active mt-2">
        {{ "STATUS.ACTIVE" | translate }}
      </span>
    </div>
    <app-button
      [label]="'BUTTONS.BOOK_VENUE' | translate"
      [classesName]="'btn-edge-cut mt-4 md:mt-0 self-start md:self-auto'"
      routerLink="/service/book-venue"
    ></app-button>
  </div>

  <!-- Relationship Manager Card -->
  <div class="card">
    <div class="flex items-center gap-4">
      <div
        class="grid place-items-center bg-dc-navy/10 text-dc-black font-semibold rounded-full w-16 h-16 shrink-0"
        >
        {{ manager.initials }}
      </div>

      <div class="grid grid-cols-1 text-dc-navy font-medium">
        <h1 class="text-lg font-semibold">{{ manager.name }}</h1>
        <span>{{ manager.title }}</span>
        <span class="leading-snug">
          {{ manager.email }}<br />{{ manager.workingHours }}
        </span>
      </div>
    </div>
    <app-button
      [label]="'BUTTONS.EMAIL' | translate"
      [classesName]="'card-edge-cut-white mt-4 md:mt-0 self-start md:self-auto'"
      (onBtnClick)="(false)"
    ></app-button>
  </div>
</div>

<!--Tab bar -->
<div class="mt-10 border border-gray-200 bg-white">
  <ul
    class="hidden md:flex overflow-x-auto scrollbar-hide bg-dc-black-200 text-dc-black text-sm font-medium border-t border-gray-200"
    >
    @for (t of tabs; track t) {
      <li
        routerLink="/business-group/{{ t.route }}"
        routerLinkActive="active-tab-item"
        class="px-4 py-3 cursor-pointer"
        >
        {{ t.label | translate }}
      </li>
    }
  </ul>

  <!-- Drop-down (mobile) -->
  <div class="md:hidden border-t border-gray-200 bg-dc-navy/10">
    <select
      class="w-full bg-transparent px-4 py-3 text-sm text-dc-navy focus:outline-none"
      (change)="goTo($event.target)"
      [value]="activeMobileRoute"
      >
      @for (t of tabs; track t) {
        <option [value]="t.route">
          {{ t.label | translate }}
        </option>
      }
    </select>
  </div>

  <!-- router for child menus -->
  <div class="p-5">
    @if (loading) {
      <app-skeleton-loader [formLoader]="true" [noOfFields]="9" />
    } @else if (loadFailed) {
      <app-validation-message type="error" [content]="{message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate}" />
    } @else {
      <router-outlet [routerOutletData]="{
        memberDetail: memberDetail,
        bgcDocuments: bgcDocuments,
        memberDocumentFolder: memberDocumentFolder,
        userCSN: userCSN,
        documentsLoading: documentsLoading,
        documentsLoadFailed: documentsLoadFailed
      }"></router-outlet>
    }
  </div>
</div>
